// Rows view for one table: toolbar (new/refresh/paginate) + table +
// floating row editor. Reads URL shape via parseRemotePath.

import { REMOTE_PAGE_SIZE } from '../functions/remoteData.js'

export const RemoteTableRows = {
  hide: (el, s) => {
    const p = el.call('parseRemotePath')
    return !p.slug || !p.table
  },
  flow: 'y',
  gap: 'Z1',

  Toolbar: {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    padding: '0 0 Z 0',

    Left: {
      flow: 'x',
      align: 'center',
      gap: 'Z',
      TotalBadge: {
        padding: 'V Z',
        round: 'Y',
        background: 'overlayStrong',
        color: 'caption',
        fontSize: 'Y2',
        fontWeight: '700',
        text: (el, s) => {
          const n = s.root?._extRowsTotal
          if (n == null) return 'loading…'
          return `${n.toLocaleString()} rows`
        }
      },
      NewRowBtn: {
        tag: 'button',
        type: 'button',
        padding: 'V Z',
        round: 'Y',
        background: 'blue',
        color: 'white',
        fontSize: 'Y2',
        fontWeight: '700',
        cursor: 'pointer',
        border: 'none',
        text: '+ New row',
        onClick: (e, el, s) => {
          const { slug, table } = el.call('parseRemotePath')
          const schema = el.call('schemaForRemoteTable', s.root, slug, table)
          const blank = {}
          for (const c of schema?.columns || []) {
            blank[c.name] = c.default != null ? String(c.default) : ''
          }
          s.root.update({
            _extEditor: { mode: 'insert', slug, table, values: blank, original: null }
          })
        }
      },
      RefreshBtn: {
        tag: 'button',
        type: 'button',
        padding: 'V Z',
        round: 'Y',
        background: 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Y2',
        cursor: 'pointer',
        text: 'Refresh',
        onClick: (e, el, s) => {
          const { slug, table } = el.call('parseRemotePath')
          el.call('loadRemoteRows', s.root, slug, table, s.root?._extRowsPage || 0)
        }
      }
    },

    Right: {
      flow: 'x',
      gap: 'Z',

      Prev: {
        tag: 'button',
        type: 'button',
        padding: 'V Z',
        round: 'Y',
        background: 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Y2',
        cursor: 'pointer',
        disabled: (el, s) => (s.root?._extRowsPage || 0) <= 0,
        text: '← Prev',
        onClick: (e, el, s) => {
          const { slug, table } = el.call('parseRemotePath')
          const page = Math.max(0, (s.root?._extRowsPage || 0) - 1)
          el.call('loadRemoteRows', s.root, slug, table, page)
        }
      },
      PageIndicator: {
        padding: 'V Z',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s) => {
          const page = s.root?._extRowsPage || 0
          const total = s.root?._extRowsTotal || 0
          const end = Math.min(total, (page + 1) * REMOTE_PAGE_SIZE)
          return `${page * REMOTE_PAGE_SIZE + 1}–${end}`
        }
      },
      Next: {
        tag: 'button',
        type: 'button',
        padding: 'V Z',
        round: 'Y',
        background: 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Y2',
        cursor: 'pointer',
        disabled: (el, s) => {
          const page = s.root?._extRowsPage || 0
          const total = s.root?._extRowsTotal || 0
          return (page + 1) * REMOTE_PAGE_SIZE >= total
        },
        text: 'Next →',
        onClick: (e, el, s) => {
          const { slug, table } = el.call('parseRemotePath')
          const page = (s.root?._extRowsPage || 0) + 1
          el.call('loadRemoteRows', s.root, slug, table, page)
        }
      }
    }
  },

  LoadingState: {
    hide: (el, s) => !s.root?._extRowsLoading,
    padding: 'C',
    textAlign: 'center',
    color: 'caption',
    fontSize: 'Z2',
    text: 'Loading rows…'
  },

  ErrorState: {
    hide: (el, s) => !s.root?._extRowsError,
    padding: 'A',
    round: 'Z1',
    background: 'overlayStrong',
    color: 'red',
    fontSize: 'Z2',
    text: (el, s) => s.root?._extRowsError || ''
  },

  Table: { extends: 'RemoteRowTable' },
  Editor: { extends: 'RemoteRowEditor' }
}
